module.exports = __webpack_public_path__ + "img/referto-2.c30e2b27.webp";